import { API_BASE_URL, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ExamService {

    static getExam(item) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        let api = `${API_BASE_URL}${dynamicPaths.getExam}`;
        const params = new URLSearchParams();

        params.append("limit", item?.limit || 25);
        params.append("page", item?.page || 1);

        if (item?.id) params.append("id", item.id);
        if (item?.status) params.append("status", item.status);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }





}

export default ExamService;
